// Sekce Dokumenty v kartě klientky (3. 11. 2026, schválený mockup): podepsané smlouvy s tlačítkem Stáhnout PDF.
// Data: /api/smlouva-podpis?akce=dokumenty (trenér vidí jen smlouvy svých klientek, vedení všechny).
import React, { useEffect, useState } from "react";
import { FileText, Download, Loader2 } from "lucide-react";
import { apiFetch } from "../../lib/api.js";
import { Oznameni, Pil } from "../sales/salesUi.jsx";

const API = "/api/smlouva-podpis";

export function useDokumentyKlientky(klientId) {
  const [stav, setStav] = useState({ nacteno: false, dokumenty: [] });
  useEffect(() => {
    if (!klientId) return undefined;
    let zive = true;
    apiFetch(`${API}?akce=dokumenty&klient_id=${encodeURIComponent(klientId)}`)
      .then((r) => (r.ok ? r.json() : { dokumenty: [] }))
      .then((j) => { if (zive) setStav({ nacteno: true, dokumenty: j.dokumenty || [] }); })
      .catch(() => { if (zive) setStav({ nacteno: true, dokumenty: [] }); });
    return () => { zive = false; };
  }, [klientId]);
  return stav;
}

function Radek({ d }) {
  const [busy, setBusy] = useState(false);
  const [chyba, setChyba] = useState("");
  const stahnout = async () => {
    setBusy(true); setChyba("");
    try {
      const r = await apiFetch(`${API}?akce=pdf&id=${d.id}`);
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.pdf_base64) throw new Error(j.error || "PDF se nepodařilo stáhnout.");
      const bin = atob(j.pdf_base64);
      const pole = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) pole[i] = bin.charCodeAt(i);
      const url = URL.createObjectURL(new Blob([pole], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url; a.download = j.soubor || "Smlouva.pdf";
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (e) { setChyba(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2">
      <div className="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-3 sm:flex-row sm:items-center sm:gap-4 sm:p-4">
        <div className="flex min-w-0 flex-1 items-center gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600"><FileText className="h-5 w-5" /></span>
          <div className="min-w-0">
            <div className="text-[15px] font-bold text-slate-900">{d.nazev}</div>
            <div className="mt-1.5 flex flex-wrap gap-1.5">
              <Pil ton="ok" mala casti={["Podepsáno", d.podepsano]} />
              <Pil ton="neutralni" mala casti={d.rezim === "dalku" ? ["na dálku"] : ["na tabletu", d.trener]} />
              {d.verze && <Pil ton="neutralni" mala casti={["verze", String(d.verze)]} />}
            </div>
          </div>
        </div>
        <button type="button" className="btn-secondary w-full justify-center sm:w-auto" onClick={stahnout} disabled={busy}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}Stáhnout PDF
        </button>
      </div>
      {chyba && <Oznameni ton="problem">{chyba}</Oznameni>}
    </div>
  );
}

export default function DokumentyKlientky({ dokumenty = [] }) {
  if (!dokumenty.length) return <div className="text-[14px] text-slate-500">Zatím žádné podepsané dokumenty.</div>;
  return <div className="space-y-3">{dokumenty.map((d) => <Radek key={d.id} d={d} />)}</div>;
}
